import {LinkText} from '@/components/atoms'
import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'
import {DateTime} from 'luxon'

/**
 * Constants for InventoryList component
 */

/**
 * Cell data mapper object for custom column rendering
 */
export const CELL_DATA_MAPPER_OBJ = {
  productId: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText
          text={original?.productId}
          id={original?.productId + ' ' + original?.id}
          handleClick={() => {
            // navigate(ROUTES.REVIEW_BULK_POINT_MODIFIERS)
          }}
        />
      </div>
    )
  },
}

/**
 * Column definitions for the sub-table (failed records)
 */
export const SUB_COLUMNS = [
  {
    columnKey: 'productId',
    header: 'Product ID',
  },
  {
    columnKey: 'warehouseId',
    header: 'Warehouse ID',
  },
  {
    columnKey: 'errorMsg',
    header: 'STATUS (REMARK)',
  },
]

/**
 * Column definitions for the main upload history table
 */
export const MAIN_COLUMNS = handleDownloadUploadError => [
  {
    columnKey: 'fileName',
    header: 'FILE PATH',
    cellData: ({row: {original}}) => (
      <div className="max-w-[200px] text-wrap break-words " title={`${original.storagePath}${original.fileName}`}>
        {`${original.storagePath}${original.fileName}`}
      </div>
    ),
  },
  {
    columnKey: 'uploadDate',
    header: 'IMPORT DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original.uploadDate)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'importStartDate',
    header: 'JOB START DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original.importStartDate)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'importEndDate',
    header: 'JOB END DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original.importEndDate)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'statistics',
    header: 'STATISTICS',
    cellData: ({row: {original}}) => (
      <div className="flex flex-col">
        {Number(original.processedCount) > 0 && <div>{original.processedCount} Records</div>}
        {Number(original.errorCount) > 0 && (
          <LinkText
            text={`${original?.errorCount} Failed`}
            id={original?.errorCount + ' ' + original?.fileUploadUUID}
            fontColor="#E46666"
            fontWeight="bold"
            handleClick={event => {
              event.stopPropagation()
              handleDownloadUploadError(original?.fileUploadUUID)
            }}
          />
        )}
      </div>
    ),
  },
  {
    columnKey: 'createdBy',
    header: 'UPLOADED BY',
    cellData: ({row: {original}}) => {
      return <div>{original.createdBy ?? 'Unknown'}</div>
    },
  },
]

/**
 * Toolbar action configuration
 */
export const TOOLBAR_ACTIONS = {
  RESET_ALL: 'resetAll',
  VIEW_UPLOAD_HISTORY: 'viewUploadHistory',
  DOWNLOAD: 'download',
}

/**
 * Messages
 */
export const MESSAGES = {
  NO_SELECTION_ERROR: 'Please select any item to download the csv file',
  INVENTORY_LIST_TITLE: 'Inventory List',
}

/**
 * UI Configuration
 */
export const UI_CONFIG = {
  BACKGROUND_COLOR: '#1D1D1D',
  MAX_SELECTION_COUNT: 10,
}

/**
 * UI Constants for component styling and text
 */
export const UI_CONSTANTS = {
  PAGE_TITLE: 'Inventory List',
  DARK_BACKGROUND: '#1D1D1D',
  TOTAL_ITEMS_TEXT: 'total items',
  DEFAULT_TOTAL_COUNT: 100,
}

// ---------------------------------------------------------------------------
// Helper: convert an ISO/UTC string to Mexico-City time string (handles DST)
// ---------------------------------------------------------------------------
const MX_ZONE = 'America/Mexico_City'
const DATE_FMT = 'yyyy-MM-dd HH:mm:ss'
const ToFormattedDateTime = iso => {
  const timeZone = useFeatureValue(growthBookFeatureFlags.AdminTimezone)
  return iso
    ? DateTime.fromISO(iso, {zone: 'utc'})
        .setZone(timeZone ? timeZone : MX_ZONE)
        .toFormat(DATE_FMT)
    : null
}
